import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EmployeeRole } from "../../user/employee/dto/role-type";

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private currentUserType: UserType | undefined = undefined;

  private _currentUserTypeForServices$ = new BehaviorSubject<UserType | undefined>(undefined);
  private _fmsAccessInsideOrganizationForServices$ = new BehaviorSubject<EmployeeRole | undefined>(undefined);
  private _isLoggedIn$ = new BehaviorSubject<boolean>(undefined);
  private _userInfo$ = new BehaviorSubject<UserInfo | undefined>(undefined);

  get userInfo(): Observable<UserInfo> {
    return this._userInfo$.asObservable();
  }

  get isAdminSuper(): boolean {
    return this._userInfo$.value?.userRole === 'ADMINSUPER';
  }

  get userInfoValue(): UserInfo {
    return this._userInfo$.value;
  }

  get isLoggedInState$(): Observable<boolean> {
    return this._isLoggedIn$.asObservable();
  }

  // viewer / admin switcher
  get currentUserTypeForServices$(): BehaviorSubject<UserType> {
    return this._currentUserTypeForServices$;
  }

  get fmsAccessInsideOrganizationForServices$(): BehaviorSubject<EmployeeRole> {
    return this._fmsAccessInsideOrganizationForServices$;
  }

  setCurrentUserTypeForServices(value: UserType): void {
    this._currentUserTypeForServices$.next(value);
  }

  setUserInfo(userInfo: UserInfo): void {
    this._userInfo$.next(userInfo);
  }

  // viewer / admin switcher
  getCurrentUserType(): UserType {
    return this.currentUserType;
  }

  changeIsLoggedIn(b: boolean): void {
    this._isLoggedIn$.next(b);
  }

  // viewer / admin switcher
  setCurrentUserType(t: UserType): void {
    localStorage.setItem('userType', t);
    this.currentUserType = t;
    this.setCurrentUserTypeForServices(t);
  }

  setFmsAccessInsideOrganization(t: EmployeeRole): void {
    this._fmsAccessInsideOrganizationForServices$.next(t);
  }
}

export type FmsRole = 'ADMINSUPER' | 'MEGAVIEWER' | 'Common';
export type PortalRole = 'NONE' | 'ADMIN';
export type UserType = 'admin' | 'viewer';

export interface UserInfo {
  id: number;
  mail: string;
  name: string;
  userRole: FmsRole;
  portalRole: PortalRole;
}
